// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"styles_filterContainer__3x8cP","title":"styles_title__Es4qT"};